import EntityTable from "@mirage/components/entityTable/EntityTable";
import { GridColDef } from "@mui/x-data-grid-premium";
import { TrackedApplicationService } from "@publicPortal/services/TrackedApplicationService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { useCallback } from "react";

const trackedApplicationService = new TrackedApplicationService();

const NotificationsTab = () => {
    const onPageRequest = useCallback(async (pageRequest: IEntityPageRequest) => {
        const notifications = await trackedApplicationService.pageNotificationsRequest(pageRequest);
        return notifications;
    }, []);

    function getColumns(): GridColDef[] {
        return [
            { field: "lastModifiedTime", headerName: "Date", type: "datetime", flex: 0.25 },
            { field: "name", headerName: "Name", flex: 0.25 },
            { field: "changes", headerName: "Changes", sortable: false, flex: 1 },
        ];
    }
    return (
        <>
            <EntityTable title="Notifications" key="notifications-tab-entityTable" stateKey="notificationsTab" onPageRequest={onPageRequest} columns={getColumns()} />
        </>
    );
};

export default NotificationsTab;
